module.exports = __webpack_public_path__ + "static/About-You-App-Mockup-3c31f41a716c7e7ba9ce802979818b18.png";